module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALBAMAAABBvoqbAAAAIVBMVEUAAADDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8jDw8gFIQruAAAACnRSTlMA2RwPvRbMx8ExdOjuQAAAAC1JREFUCNdjYGAImcDAwCrlwMCguMyAgUmqGMhYYcDA4LWUAcICi4FlwerAOgDl7Qh0Q2IUVwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_prev2_hover.png
// module id = KfLo
// module chunks = 9